import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header-notification',
  templateUrl: './header-notification.component.html',
  styleUrls: ['./header-notification.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderNotificationComponent implements OnInit {
  constructor(public translate: TranslateService) {}
  items!: MenuItem[];
  ngOnInit(): void {
    this.items = [
      {
        label: 'Notification 1',
        command: () => {},
      },
      {
        label: 'Notification 2',
        command: () => {},
      },
      {
        label: 'Notification 3',
        command: () => {},
      },
      {
        label: 'Notification 4',
        command: () => {},
      },
      {
        label: 'Notification 5',
        command: () => {},
      },
    ];
  }
}
